import { createFileRoute } from "@tanstack/react-router";
import { AllowanceClaimsHelp } from "./AllowanceClaimsFAQ";

export const Route = createFileRoute("/_auth/_app/claims/help/allowance")({
  component: AllowanceClaimsHelp,
});
